// Barra de progreso + regalo automatico "gasta X en la coleccion Halloween".
// Reutiliza el mismo patron que la barra de envio gratis (cart.js,
// CartItems.cartShipping) pero de forma independiente, para no tocar ese
// archivo compartido. Se engancha al mismo evento de carrito que ya usa el
// tema (PUB_SUB_EVENTS.cartUpdate, pubsub.js/constants.js) para refrescarse
// tras cualquier "Añadir al carrito", sin necesidad de recargar la pagina.
(function () {
	function init() {
		var configEl = document.getElementById('halloween-gift-config')
		if (!configEl) return

		var config
		try {
			config = JSON.parse(configEl.textContent)
		} catch (e) {
			return
		}
		if (!config.enabled || !config.variantId || !config.thresholdCents) return

		var productIds = Array.isArray(config.productIds) ? config.productIds : []
		var syncing = false
		var pending = false

		function getThresholdCents() {
			// Mismo ajuste de divisa que ya usa la barra de envio gratis
			// (cart.js, CartItems.cartShipping): el importe del ajuste se
			// introduce en la divisa del shop, pero /cart.js devuelve los
			// importes en la divisa de presentacion activa (Shopify Markets).
			var rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1
			return Math.round(config.thresholdCents * rate)
		}

		function updateBars(eligibleSubtotal, thresholdCents) {
			var bars = document.querySelectorAll('.cart-halloween-gift')
			if (!bars.length) return

			var progress = (eligibleSubtotal / thresholdCents) * 100
			if (progress > 100) progress = 100
			if (progress < 0) progress = 0
			var unlocked = eligibleSubtotal >= thresholdCents

			bars.forEach(function (bar) {
				var progressPrev = getComputedStyle(
					bar.querySelector('.cart-halloween-gift__progress-current')
				).getPropertyValue('width')
				document.documentElement.style.setProperty(
					'--progress-prev-halloween',
					progressPrev
				)

				var defaultMessage = bar.querySelector(
					'.cart-halloween-gift__message_default'
				)
				var successMessage = bar.querySelector(
					'.cart-halloween-gift__message_success'
				)

				if (unlocked) {
					if (defaultMessage) defaultMessage.classList.remove('active')
					if (successMessage) successMessage.classList.add('active')
				} else {
					if (typeof formatMoney === 'function' && defaultMessage) {
						var remaining = thresholdCents - eligibleSubtotal
						defaultMessage.innerText = (bar.dataset.message || '').replace(
							'||amount||',
							formatMoney(remaining)
						)
					}
					if (defaultMessage) defaultMessage.classList.add('active')
					if (successMessage) successMessage.classList.remove('active')
				}

				var currentEl = bar.querySelector(
					'.cart-halloween-gift__progress-current'
				)
				if (currentEl) currentEl.style.width = progress + '%'
			})
		}

		function sync() {
			if (syncing) {
				pending = true
				return
			}
			syncing = true

			fetch('/cart.js')
				.then(function (response) {
					return response.json()
				})
				.then(function (cart) {
					var giftLine = null
					var eligibleSubtotal = 0

					cart.items.forEach(function (item) {
						var isGift =
							item.variant_id === config.variantId &&
							item.properties &&
							item.properties._regalo_halloween === 'si'

						if (isGift) {
							giftLine = item
						} else if (productIds.indexOf(item.product_id) !== -1) {
							eligibleSubtotal += item.final_line_price
						}
					})

					var thresholdCents = getThresholdCents()
					updateBars(eligibleSubtotal, thresholdCents)

					var shouldHaveGift = eligibleSubtotal >= thresholdCents

					if (shouldHaveGift && !giftLine) {
						return fetch('/cart/add.js', {
							method: 'POST',
							headers: { 'Content-Type': 'application/json' },
							body: JSON.stringify({
								items: [
									{
										id: config.variantId,
										quantity: 1,
										properties: { _regalo_halloween: 'si' },
									},
								],
							}),
						}).then(handleCartResponse)
					}

					if (!shouldHaveGift && giftLine) {
						return fetch('/cart/change.js', {
							method: 'POST',
							headers: { 'Content-Type': 'application/json' },
							body: JSON.stringify({ id: giftLine.key, quantity: 0 }),
						}).then(handleCartResponse)
					}
				})
				.catch(function () {})
				.finally(function () {
					syncing = false
					if (pending) {
						pending = false
						sync()
					}
				})
		}

		function handleCartResponse(response) {
			// Si Shopify rechaza el add/change (p. ej. variante regalo sin stock,
			// error 422), no se avisa de un cambio que no ha ocurrido de verdad;
			// el siguiente cartUpdate volvera a intentarlo.
			if (!response.ok) return
			notifyCartUpdate()
		}

		function notifyCartUpdate() {
			if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
				publish(PUB_SUB_EVENTS.cartUpdate, { source: 'halloween-gift' })
			}
		}

		sync()

		if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
			subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
				if (event && event.source === 'halloween-gift') return
				sync()
			})
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init)
	} else {
		init()
	}
})()
